import { StyleRulesCallback, withStyles, WithStyles } from '@material-ui/core/styles';
import * as React from 'react';
import { pure } from 'recompose';
import { Theme } from '@material-ui/core';
import * as cx from 'classnames';
import { WithChildren } from '../shared/WithChildren';
import { BpM } from '../shared/brakepoints';

type CssClasses = 'scrollable' | 'padding';

const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  scrollable: {
    [BpM()]: {
      height: '88vh !important',
      overflowY: 'auto',
    },
  },
  padding: {
    padding: theme.spacing.unit * 2,
  },
});

interface OwnProps {
  padding?: boolean;
  className?: string;
}

type Props = OwnProps & WithStyles<CssClasses> & WithChildren;

const YScrollable = ({ classes, children, padding, className }: Props) => (
  <div className={cx(classes.scrollable, padding ? classes.padding : undefined, className)}>{children}</div>
);

export default pure(withStyles(styles)(YScrollable));



// WEBPACK FOOTER //
// ./src/components/YScrollable.tsx